import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Hormones — 20×20 lab group icon (Figma 835:65 / vector 834:3).
 * Single thermometer-style vector layer 5×16.6667, inset 8.33%/37.5%.
 */
const IconHormones: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(7.5 1.666)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.416667 0C0.186542 0 0 0.18655 0 0.416667V1.66667C0 1.89678 0.186542 2.08333 0.416667 2.08333H0.833333V3.03037C0.590583 3.11617 0.416667 3.34767 0.416667 3.61979V14.5833C0.416667 15.7339 1.34942 16.6667 2.5 16.6667C3.65058 16.6667 4.58333 15.7339 4.58333 14.5833V3.61979C4.58333 3.34767 4.40942 3.11617 4.16667 3.03037V2.08333H4.58333C4.81346 2.08333 5 1.89678 5 1.66667V0.416667C5 0.18655 4.81346 0 4.58333 0H0.416667ZM1.66667 3.20312V2.08333H3.33333V3.20312C3.33333 3.47525 3.50725 3.70675 3.75 3.79254V5.83333H1.25V3.79254C1.49275 3.70675 1.66667 3.47525 1.66667 3.20312Z"
        />
      </g>
    </IconBase>
  );
};

export default IconHormones;
